<template>
    <div class="part" :id="`part${_uid}`">
        <form
            autocomplete="off"
            class="form form-inline"
            role="form"
            ref="form"
        >
            <!-- HEADER TODO: flexbox? -->
            <div
                class="w-100 mb-3"
                :class="{
                    partNo: !financialRisk,
                    partNoRed: financialRisk,
                }"
                :id="part.ID"
            >
                <div class="d-flex justify-content-between my-1">
                    <!-- TODO: only for enquiry, order part doesnt have it, seems how old code worked, check -->
                    <div>
                        <a
                            v-if="
                                knowledgeBaseAccess &&
                                part.part_quoted_elsewhere
                            "
                            target="_blank"
                            :href="part.knowledgebase_url"
                            >{{ partTitle }}</a
                        >
                        <a v-else>{{ partTitle }}</a>
                    </div>
                    <div v-if="!disabled">
                        <div
                            v-if="updating"
                            class="spinner-border spinner-border-sm mr-2"
                            style="margin-bottom: 2px"
                            role="status"
                            aria-hidden="true"
                        ></div>
                        <button
                            class="btn btn-success btn-sm btn-glow"
                            :disabled="!needsUpdating || invalidData"
                            :title="
                                __(
                                    invalidData
                                        ? 'Part has Invalid data!'
                                        : needsUpdating
                                        ? 'Update Part'
                                        : 'Part does not need updating.'
                                )
                            "
                            @click.prevent="tryUpdate"
                        >
                            <i class="fas fa-save"></i>
                        </button>
                        <button
                            class="btn btn-success btn-sm"
                            :disabled="order || updating"
                            :title="
                                __(
                                    order
                                        ? 'Cannot add new parts to an order.'
                                        : ''
                                )
                            "
                            @click.prevent="tryDuplicate"
                        >
                            <i class="fas fa-copy"></i>
                        </button>
                        <button
                            class="btn btn-danger btn-sm ml-2"
                            :disabled="order || updating"
                            :title="
                                __(
                                    order
                                        ? 'Cannot delete parts from an order.'
                                        : ''
                                )
                            "
                            @click.prevent="tryDelete"
                        >
                            <i class="fas fa-trash"></i>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Supplier quantity and condition row -->
            <div
                class="form-group w-100"
                :class="{
                    'mb-2': !isEbay,
                    'mb-1': isEbay,
                }"
            >
                <div class="col-xl-2">
                    <input
                        class="form-control w-100"
                        type="number"
                        step="1"
                        min="1"
                        max="10000"
                        v-model.number="qty"
                        :disabled="updating || disabled"
                        required
                    />
                </div>
                <div class="col">
                    <api-search
                        class="w-100"
                        :route="'enquiries/fragment/parts/searchSupplier'"
                        :initial-query="
                            supplierID > 0 && part.part_supplier
                                ? part.part_supplier.supplier.supplierName
                                : null
                        "
                        :autocomplete-css="'max-height: 142px;'"
                        :disabled="
                            updating || disabled || (order && supplierDisabled)
                        "
                        :required="!order"
                        :placeholder="'Search for Supplier'"
                    >
                        <template v-slot="row">
                            <a
                                class="dropdown-item"
                                @click.stop.prevent="
                                    supplierClick(row.item, row.defocus)
                                "
                                href="#"
                            >
                                <span
                                    class="supplierName"
                                    v-html="row.item.supplierName"
                                ></span>
                            </a>
                        </template>
                        <template v-slot:append>
                            <div class="input-group-append">
                                <span class="input-group-text">
                                    <i
                                        class="fas"
                                        :class="
                                            supplierID > 0
                                                ? 'fa-check text-success'
                                                : 'fa-times text-danger'
                                        "
                                        aria-hidden="true"
                                    ></i>
                                </span>
                            </div>
                        </template>
                    </api-search>
                </div>
                <div class="col-xl-3">
                    <select
                        class="form-control w-100 custom-select"
                        v-model="conditionID"
                        required
                        :disabled="
                            updating || disabled || 4 === part.part.categoryID
                        "
                    >
                        <option
                            v-for="condition in conditions"
                            :key="condition.ID"
                            :value="condition.ID"
                        >
                            {{ __(condition.conditionEN) }}
                        </option>
                    </select>
                </div>
            </div>

            <!-- Ebay row -->
            <div class="form-group w-100 mb-2" v-if="isEbay">
                <div class="col-xl-2">
                    <label
                        :for="_uid + 'ebayNo'"
                        class="d-block control-label text-left"
                        >{{ __("eBay ID") }}</label
                    >
                </div>
                <div class="col">
                    <input
                        class="form-control w-100"
                        :id="_uid + 'ebayNo'"
                        type="text"
                        v-model="ebayNo"
                        :disabled="updating || disabled"
                        required
                        data-lpignore="true"
                        pattern="[0-9]{9,19}"
                    />
                </div>
                <div class="col-xl-3">
                    <select
                        class="form-control w-100 custom-select"
                        v-model="currencyID"
                        :disabled="updating || disabled"
                        required
                    >
                        <option
                            v-for="_currency in currencies"
                            :key="_currency.ID"
                            :value="_currency.ID"
                        >
                            {{
                                _currency.currency +
                                " (" +
                                _currency.symbol +
                                ")"
                            }}
                        </option>
                    </select>
                </div>
            </div>

            <!--  buy row -->
            <div class="form-group w-100 mb-1">
                <div class="col-xl-3">
                    <label
                        :for="_uid + 'buyFor'"
                        class="d-block control-label text-left"
                        >{{ __("Buy For") }} ({{ currencySymbol }})</label
                    >
                    <input
                        class="form-control w-100"
                        :id="_uid + 'buyFor'"
                        type="number"
                        step="0.01"
                        v-model.number="buyValue"
                        :disabled="updating || disabled"
                        required
                        ref="buyForInput"
                    />
                </div>

                <div class="col-xl-3">
                    <label
                        :for="_uid + 'buyCarriageIn'"
                        class="d-block control-label text-left"
                        >{{ __("Carriage In") }} ({{ currencySymbol }})</label
                    >
                    <input
                        class="form-control w-100"
                        :id="_uid + 'buyCarriageIn'"
                        type="number"
                        step="0.01"
                        min="0"
                        v-model.number="buyCarriageIn"
                        :disabled="updating || disabled"
                        required
                    />
                </div>

                <div class="col-xl-3">
                    <label
                        :for="_uid + 'buyCarriageOut'"
                        class="d-block control-label text-left"
                        >{{ __("Carriage Out") }} ({{
                            DEFAULT_CURRENCY_SYMBOL
                        }})</label
                    >
                    <input
                        class="form-control w-100"
                        :id="_uid + 'buyCarriageOut'"
                        type="number"
                        step="0.01"
                        min="0"
                        v-model.number="buyCarriageOut"
                        :disabled="updating || disabled"
                        required
                    />
                </div>

                <div class="col-xl-3">
                    <label
                        :for="_uid + 'buyTotal'"
                        class="d-block control-label text-left"
                        >{{ __("Total") }} ({{ currencySymbol }})</label
                    >
                    <input
                        class="form-control w-100"
                        :id="_uid + 'buyTotal'"
                        type="text"
                        v-model="buyTotal"
                        :disabled="updating || disabled"
                        readonly
                    />
                </div>
            </div>

            <!-- sell row -->
            <div class="form-group w-100 mb-3">
                <div class="col-xl-3">
                    <label
                        :for="_uid + 'sellFor'"
                        class="d-block control-label text-left"
                        >{{ __("Sell For") }} ({{ currency.symbol }})</label
                    >
                    <input
                        class="form-control w-100"
                        :id="_uid + 'sellFor'"
                        type="number"
                        step="0.01"
                        v-model.number="saleValue"
                        :disabled="order || updating || disabled"
                        required
                    />
                </div>

                <div class="col-xl-3">
                    <label
                        :for="_uid + 'saleCarriage'"
                        class="d-block control-label text-left"
                        >{{ __("Carriage") }} ({{ currency.symbol }})</label
                    >
                    <input
                        class="form-control w-100"
                        :id="_uid + 'saleCarriage'"
                        type="number"
                        step="0.01"
                        min="0"
                        v-model.number="saleCarriage"
                        :disabled="order || updating || disabled"
                        required
                    />
                </div>

                <div class="offset-xl-3 col-xl-3">
                    <label
                        :for="_uid + 'saleTotal'"
                        class="d-block control-label text-left"
                        >{{ __("Total") }} ({{ currency.symbol }})</label
                    >
                    <input
                        class="form-control w-100"
                        :id="_uid + 'saleTotal'"
                        type="text"
                        v-model="saleTotal"
                        :disabled="order || updating || disabled"
                        readonly
                    />
                </div>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: "EnqPart",

    props: {
        part: {
            required: true,
            type: Object,
        },

        currency: {
            required: true,
            type: Object,
        },

        exchangeRates: {
            required: true,
            type: Object,
        },

        currencies: {
            required: true,
            type: Array,
        },

        conditions: {
            required: true,
            type: Array,
        },

        index: {
            required: true,
            type: Number,
        },

        disabled: {
            required: true,
            type: Boolean,
        },

        supplierDisabled: {
            required: true,
            type: Boolean,
        },

        order: {
            required: true,
            type: Boolean,
        },

        financialRisk: {
            required: true,
            type: Boolean,
        },

        onUpdated: {
            required: true,
            type: Function,
        },

        onDuplicated: {
            required: true,
            type: Function,
        },

        onDeleted: {
            required: true,
            type: Function,
        },

        focus: {
            required: true,
            type: Boolean,
        },
    },

    data() {
        return {
            updating: false,
            needsUpdating: false,

            supplierID: this.part.part_supplier
                ? this.part.part_supplier.supplierID
                : 0,
            ebayNo:
                this.part.part_supplier && this.part.part_supplier.ebay_no
                    ? this.part.part_supplier.ebay_no.ebayNo
                    : null,
            conditionID: this.part.conditionID,
            currencyID:
                this.part.part_supplier &&
                this.part.part_supplier.supplierID !== 37 &&
                this.part.part_supplier.supplierID !== 0
                    ? this.part.part_supplier.supplier.currencyID
                    : this.part.currencyID,
            qty: this.part.qty,
            buyValue: this.part.buyValue,
            buyCarriageIn: this.part.buyCarriageIn,
            buyCarriageOut: this.part.buyCarriageOut,
            saleCarriage: this.part.saleCarriage,
            saleValue: this.part.saleValue,
        };
    },

    computed: {
        knowledgeBaseAccess() {
            return authed.permissions.includes("access knowledge base");
        },

        currencySymbol() {
            let symbol = DEFAULT_CURRENCY_SYMBOL;

            this.currencies.forEach((_currency) => {
                if (_currency.ID === this.currencyID) {
                    symbol = _currency.symbol;
                }
            });

            return symbol;
        },

        // why parse float hell? the 'invalid' value for .number is an EMPTY STRING
        // i am NOT JOKING. it isn't NaN, it isn't undefined, it's an EMPTY STRING
        totalBuyValue() {
            return (
                parseFloat(this.buyValue) * parseFloat(this.qty) +
                parseFloat(this.buyCarriageIn)
            );
        },

        buyCarriageOutConverted() {
            let out = parseFloat(this.buyCarriageOut);

            if (0.0 === out) {
                return 0.0;
            }

            if (this.part.currency.ID !== DEFAULT_CURRENCY_ID) {
                out *= this.exchangeRates[
                    DEFAULT_CURRENCY_CURRENCY +
                        "to" +
                        this.part.currency.currency
                ];
            }

            return out;
        },

        buyTotalRaw() {
            this.$parent.$emit("child-total-updated");
            return (
                parseFloat(this.totalBuyValue) +
                parseFloat(this.buyCarriageOutConverted)
            );
        },

        buyTotal() {
            return number_format(this.buyTotalRaw, 2);
        },

        saleTotalRaw() {
            this.$parent.$emit("child-total-updated");
            return (
                parseFloat(this.saleValue) * parseFloat(this.qty) +
                parseFloat(this.saleCarriage)
            );
        },

        saleTotal() {
            return number_format(this.saleTotalRaw, 2);
        },

        partTitle() {
            let part = this.part.part;
            let text =
                (this.index + 1).toString() +
                ". " +
                part.manufacturer.manufacturerName +
                " " +
                part.partNo;

            return text.slice(0, 45) + (text.length > 45 ? "..." : "");
        },

        isEbay() {
            return 37 === this.supplierID;
        },

        invalidData() {
            if (
                isNaN(this.saleTotalRaw) ||
                !isFinite(this.saleTotalRaw) ||
                isNaN(this.buyTotalRaw) ||
                !isFinite(this.buyTotalRaw) ||
                this.supplierID <= 0 ||
                (this.$refs.form && !this.$refs.form.checkValidity())
            ) {
                return true;
            }

            return false;
        },
    },

    methods: {
        supplierClick(supplier, callback) {
            this.supplierID = supplier.ID;
            this.currencyID = supplier.SupplierSystemCurrency.ID;

            callback(supplier.supplierName);
            this.$parent.$emit("child-total-updated");
        },

        makeNeedUpdate(_new, old) {
            if (old === undefined || _new === old) {
                // not on first update
                return;
            }

            this.needsUpdating = true;
        },

        getParamsForPost() {
            return {
                supplierID: this.supplierID,
                ebayNo: this.isEbay ? this.ebayNo : undefined,
                conditionID: this.conditionID,
                currencyID: this.currencyID,
                qty: this.qty,
                buyValue: this.buyValue,
                buyCarriageIn: this.buyCarriageIn,
                buyCarriageOut: this.buyCarriageOut,
                saleCarriage: this.saleCarriage,
                saleValue: this.saleValue,
            };
        },

        tryUpdate() {
            if (!this.$refs.form.checkValidity()) {
                return;
            }

            this.updating = true;
            this.needsUpdating = false;
            $("input").blur();

            this.onUpdated(this.index, this.getParamsForPost());
            this.$parent.$emit("child-total-updated");
        },

        tryDuplicate() {
            this.updating = true;
            this.needsUpdating = false;

            this.onDuplicated(this.index);
            this.$parent.$emit("child-total-updated");
        },

        tryDelete() {
            this.updating = true;
            this.needsUpdating = false;

            this.onDeleted(this.index);
            this.$parent.$emit("child-total-updated");
        },
    },

    watch: {
        part: function (part) {
            if (this.updating) {
                this.updating = false;
            }

            this.supplierID = part.part_supplier
                ? part.part_supplier.supplierID
                : 0;
            this.ebayNo =
                part.part_supplier && part.part_supplier.ebay_no
                    ? part.part_supplier.ebay_no.ebayNo
                    : null;
            this.conditionID = part.conditionID;
            this.currencyID = part.currencyID;
            this.qty = part.qty;
            this.buyValue = part.buyValue;
            this.buyCarriageIn = part.buyCarriageIn;
            this.buyCarriageOut = part.buyCarriageOut;
            this.saleCarriage = part.saleCarriage;
            this.saleValue = part.saleValue;

            this.needsUpdating = false;
        },

        supplierID: function (_new, old) {
            this.makeNeedUpdate(_new, old);
        },
        ebayNo: function (_new, old) {
            this.makeNeedUpdate(_new, old);
        },
        conditionID: function (_new, old) {
            this.makeNeedUpdate(_new, old);
        },
        currencyID: function (_new, old) {
            this.makeNeedUpdate(_new, old);
        },
        qty: function (_new, old) {
            this.makeNeedUpdate(_new, old);
        },
        buyValue: function (_new, old) {
            this.makeNeedUpdate(_new, old);
        },
        buyCarriageIn: function (_new, old) {
            this.makeNeedUpdate(_new, old);
        },
        buyCarriageOut: function (_new, old) {
            this.makeNeedUpdate(_new, old);
        },
        saleCarriage: function (_new, old) {
            this.makeNeedUpdate(_new, old);
        },
        saleValue: function (_new, old) {
            this.makeNeedUpdate(_new, old);
        },
    },

    mounted() {
        make_input_no_0();
        if (true === this.focus) {
            this.$refs.buyForInput.focus();
        }
    },
};
</script>
